<template>
  <div
    class="header-static"
    :style="{ backgroundImage: `url(${bgImg})`, backgroundColor: bgC}"
    :class="{'headdark':headdark}"
  >
    <b-container class="d-flex flex-column justify-content-center align-items-center">
      <div class="d-flex justify-content-center align-items-center">
        <img
          class="icon"
          v-if="data && data.img != null && data.img.url"
          :src="data.img.url"
          alt="icon"
        />
        <h1 class="ttl" :style="{ color: textColor}">{{data && data.title}}</h1>
      </div>
      <!--					<h3 class="subttl"></h3>-->
      <b-breadcrumb :items="items" :style="{ color: textColor}"></b-breadcrumb>
    </b-container>
  </div>
</template>

<script>
const axios = require("axios");
export default {
  props: {
    headdark: Boolean,
    bgImg: String,
    bgC: String,
    ttl: String,
    textColor: String
  },
  data() {
    return {
      data: null,
      items: null
    };
  },
  beforeMount() {
    axios
      .get(`${this.$root.routLink}${this.$route.path}?ajax&act=page_head`, {
        responseType: "json"
      })
      .then(({ data }) => {
        this.data = JSON.parse(data.addons);
        this.items = this.data.brdcr;
      });
  }
};
</script>

<style lang="scss" scoped>
.header-static {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: right;
  padding-top: 20px;
  padding-bottom: 75px;
  @media only screen and (max-width: $md),
    only screen and (max-device-width: $md) {
    padding-top: 50px;
    padding-bottom: 20px;
  }
  .ttl {
    margin-bottom: 13px;
    font-weight: 500;
    font-size: 44px;
    line-height: 110.1%;
    color: $defaultColor;
    @media only screen and (max-width: $sm),
      only screen and (max-device-width: $sm) {
      font-size: 26px;
    }
  }
  .icon {
    height: 2.7rem;
    margin-right: 15px;
  }
  .breadcrumb {
    background: transparent;
    padding: 0;
    &-item {
      font-size: 16px;
      line-height: 70%;

      &::before {
        color: $activeColor;
        font-weight: 500;
        font-size: 16px;
        line-height: 100%;
      }
      a {
        color: $defaultColor;
      }
      &.active {
        color: $defaultColor;
      }
    }
  }
  &.headdark {
    .breadcrumb {
      &-item {
        &::before {
          color: $defaultColor;
        }
        a {
          color: $defaultColor;
        }
        &.active {
          color: $defaultColor !important;
        }
      }
    }
  }
}
</style>